import { Button } from '../ui/button';
import { Plus } from 'lucide-react';

export function PageHeader({ title, description, action, actionLabel, actionIcon: ActionIcon = Plus }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
      <div>
        <h1 className="text-2xl font-bold text-white tracking-tight" data-testid="page-title">
          {title}
        </h1>
        {description && (
          <p className="text-sm text-slate-500 mt-1">{description}</p>
        )}
      </div>
      {action && (
        <Button 
          onClick={action}
          className="bg-green-500 hover:bg-green-600 text-slate-900 font-bold shadow-[0_0_15px_rgba(34,197,94,0.3)]"
          data-testid="page-action-btn"
        >
          <ActionIcon className="w-4 h-4 mr-2" />
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
